import { getSupplyChainCosts } from './get-supply-chain-costs'

export const supplyChainCostsApi = {
  getSupplyChainCosts: getSupplyChainCosts,
}
